import dayjs from "dayjs";
import { Badge, Modal } from "react-bootstrap";
import styles from "./ronda_modal.module.css";
import iconLocationOff from "../../../img/icons/location_off.svg";
import iconLocationOn from "../../../img/icons/location_on.svg";
import iconNfcOff from "../../../img/icons/nfc_off.svg";
import { useState } from "react";

interface StatusRonda {
    id_status: number;
    descricao: string;
}

interface Colaborador {
    id_colaborador: number;
    matricula: number;
    data_admissao: string;
    data_nascimento: string;
    id_empresa: number;
    nome_completo: string;
    id_escala: number;
    escala: string;
    id_cargo: number;
    cargo: string;
}

interface Checkpoint {
    id_scan: number;
    id_qrcode: any;
    id_ronda_registro: string | null;
    id_colaborador: number;
    data_criacao: string;
    data_dia: string;
    modo_registro: string;
    data_recebido: string | null;
    longitude: string;
    latitude: string;
    internet: string;
    conexao: string;
    obs: string | null;
    status_m: string;
}

interface Ocorrencia {
    id_ronda_ocorrencia: string;
    data_criacao: string;
    data_recebido: string | null;
    id_colaborador: number;
    id_ronda_registro: string;
    id_qrcode: any;
    observacao: string;
    foto_filename: string;
    foto_key: string;
    foto_link: string;
}

interface RondaCadastro {
    id_ronda: number;
    data_criacao: string;
    descricao: string;
    id_centro_custo: number;
    tempo_estimado: string;
    latitude: string | null;
    longitude: string | null;
    situacao: number;
}

interface RondaRegistro {
    id_ronda_registro: string;
    id_status: number;
    data_inicio: string;
    data_fim?: string | null;
    data_recebido: string | null;
    id_colaborador: number;
    id_ronda: number;
    tempo_ronda: number;
    ronda: RondaCadastro;
    colaborador: Colaborador;
    ronda_status: StatusRonda;
    registros_pontos: Checkpoint[];
    registros_ocorrencias: Ocorrencia[];
}

export default function RondaRegistroModal({ show, handleClose, rondaRegistro }: iProps) {
    const rondaLocalizacao = formatarLocalizacao(rondaRegistro.ronda.latitude, rondaRegistro.ronda.longitude);
    const inicio = formatarDataHora(rondaRegistro.data_inicio);
    const termino = formatarDataHora(rondaRegistro.data_fim);
    const duracao = formatarDuracao(rondaRegistro.data_inicio, rondaRegistro.data_fim);
    const rondaRegistros = rondaRegistro.registros_pontos;
    const rondaOcorrencias = rondaRegistro.registros_ocorrencias;
    return (
        <Modal id={styles.modal_ronda_registro} show={show} onHide={handleClose} backdrop="static" keyboard={true} size="lg">
            <Modal.Header closeButton className="div-row">
                <div>
                    <div className={styles["ronda-modal__title-row"]}>
                        <Modal.Title as="h5" className={styles["ronda-modal__title"]}>
                            Ronda: {rondaRegistro.ronda.descricao}
                        </Modal.Title>
                        <Badge className={`${styles["ronda-status-badge"]} ${styles[`ronda-status-badge--${rondaRegistro.id_status}`]}`}>{rondaRegistro.ronda_status.descricao}</Badge>
                    </div>
                    <span className={styles["ronda-modal__id"]}>{rondaRegistro.id_ronda_registro}</span>
                    {rondaRegistro.data_recebido !== null && <span className={styles["ronda-modal__id"]}>Sincronizado em: {formatarDatatime(rondaRegistro.data_recebido)}</span>}
                    {rondaLocalizacao !== "-" && (
                        <span className={styles["ronda-modal__location"]}>
                            <img src={iconLocationOn} alt="iconLocationOn" width={10} /> Local - {rondaLocalizacao}
                        </span>
                    )}
                </div>
            </Modal.Header>
            <Modal.Body>
                <section className={styles["ronda-card"]}>
                    <div className={styles["ronda-colaborador"]}>
                        <div className={styles["ronda-avatar"]}>{iniciais(rondaRegistro.colaborador.nome_completo)}</div>
                        <div className={styles["ronda-colaborador__info"]}>
                            <p className={styles["ronda-colaborador__nome"]}>
                                {rondaRegistro.colaborador.matricula} - {rondaRegistro.colaborador.nome_completo}
                            </p>
                            <p className={styles["ronda-colaborador__detalhe"]}>
                                Admissão {formatarDate(rondaRegistro.colaborador.data_admissao)} · Escala {rondaRegistro.colaborador.id_escala} - {rondaRegistro.colaborador.escala} · Cargo {rondaRegistro.colaborador.cargo}
                            </p>
                        </div>
                    </div>

                    <div className={styles["ronda-metrics"]}>
                        <div className={styles["ronda-metric"]}>
                            <span className={styles["ronda-metric__label"]}>Duração</span>
                            <span className={styles["ronda-metric__value"]}>{duracao}</span>
                        </div>
                        <div className={styles["ronda-metric"]}>
                            <span className={styles["ronda-metric__label"]}>Início</span>
                            <span className={`${styles["ronda-metric__value"]} ${styles["ronda-metric__value--sm"]}`}>{inicio?.hora ?? "—"}</span>
                            {inicio && <span className={styles["ronda-metric__sub"]}>{inicio.data}</span>}
                        </div>
                        <div className={styles["ronda-metric"]}>
                            <span className={styles["ronda-metric__label"]}>Término</span>
                            <span className={`${styles["ronda-metric__value"]} ${styles["ronda-metric__value--sm"]}`}>{termino?.hora ?? "—"}</span>
                            {termino && <span className={styles["ronda-metric__sub"]}>{termino.data}</span>}
                        </div>
                    </div>
                </section>

                <section className={styles["ronda-card"]}>
                    <div className={styles["ronda-section__header"]}>
                        <p className={styles["ronda-section__title"]}>Registros da ronda</p>
                        <span className={styles["ronda-section__count"]}>{rondaRegistros.length} qrcodes</span>
                    </div>

                    {rondaRegistros.length === 0 ? (
                        <div className={styles["ronda-empty-state"]}>
                            <img src={iconNfcOff} alt="icon_nfc_off" width={20} />
                            <p>Nenhum qrcode escaneado nesta ronda</p>
                        </div>
                    ) : (
                        <ul className={styles["ronda-checkpoint-list"]}>
                            {rondaRegistros.map((registro) => {
                                let modo_registro = "TAG QRCODE";
                                if (registro.modo_registro === "nfc") {
                                    modo_registro = "TAG NFC";
                                }
                                let localizacao = formatarLocalizacao(registro.latitude, registro.longitude);
                                return (
                                    <li key={registro.id_scan} className={styles["ronda-checkpoint-list__item"]}>
                                        <div>
                                            <span className={styles["ronda-checkpoint-list__horario"]}>{formatarDatatime(registro.data_criacao)}</span>
                                            <span className={styles["ronda-checkpoint-list__info"]}>{registro.id_qrcode.descricao}</span>
                                            <span className={styles["ronda-checkpoint-list__info"]}>
                                                {registro.internet} - {registro.conexao} - {modo_registro}
                                            </span>
                                        </div>
                                        {localizacao === "-" && (
                                            <span className="div-row">
                                                <img src={iconLocationOff} width="15" alt="iconLocationOff" /> Não disponível
                                            </span>
                                        )}
                                        {localizacao !== "-" && <span className="div-row"><img src={iconLocationOn} width="15" alt="icon_location_on" /> {localizacao}</span>}
                                    </li>
                                );
                            })}
                        </ul>
                    )}
                </section>

                <section className={styles["ronda-card"]}>
                    <div className={styles["ronda-section__header"]}>
                        <p className={styles["ronda-section__title"]}>Registros de Ocorrências</p>
                        <span className={`${styles["ronda-section__count"]} ${styles["ronda-section__count--destaque"]}`}>
                            {rondaOcorrencias.length} {rondaOcorrencias.length === 1 ? "registrada" : "registradas"}
                        </span>
                    </div>

                    {rondaOcorrencias.length === 0 ? (
                        <div className={styles["ronda-empty-state"]}>
                            <p>Nenhuma ocorrência registrada nesta ronda</p>
                        </div>
                    ) : (
                        <div className={styles["ronda-occurrence-list"]}>
                            {rondaOcorrencias.map((ocorrencia) => {
                                const dataHora = formatarDataHora(ocorrencia.data_criacao);
                                const data_recebido = formatarDatatime(ocorrencia.data_recebido);
                                return (
                                    <article key={ocorrencia.id_ronda_ocorrencia} className={styles["ronda-occurrence-card"]}>
                                        {ocorrencia.foto_link && <OcorrenciaFoto src={ocorrencia.foto_link} />}
                                        <div className={styles["ronda-occurrence-card__conteudo"]}>
                                            <div className={styles["ronda-occurrence-card__topo"]}>
                                                <span className={styles["ronda-occurrence-card__data"]}>{dataHora ? `${dataHora.data} · ${dataHora.hora}` : "—"}</span>
                                            </div>
                                            <p className={styles["ronda-occurrence-card__texto"]}>{ocorrencia.observacao}</p>
                                            {data_recebido !== "-" && <span>Data recebido: {data_recebido}</span>}
                                        </div>
                                    </article>
                                );
                            })}
                        </div>
                    )}
                </section>
            </Modal.Body>
            <Modal.Footer style={{ width: "100%" }}></Modal.Footer>
        </Modal>
    );
}

function formatarDatatime(datetime: string | null): string {
    if (datetime === null) {
        return "-";
    }
    return dayjs(datetime).format("DD/MM/YYYY HH:mm:ss");
}

function formatarDate(date: string | null): string {
    if (date === null) {
        return "-";
    }
    return dayjs(date).format("DD/MM/YYYY");
}

interface iProps {
    show: boolean;
    handleClose: any;
    rondaRegistro: RondaRegistro;
}

function formatarDataHora(valor?: string | null): { data: string; hora: string } | null {
    if (!valor) return null;
    const dt = new Date(valor);
    if (Number.isNaN(dt.getTime())) return null;
    return {
        data: dt.toLocaleDateString("pt-BR"),
        hora: dt.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit", second: "2-digit" }),
    };
}

function iniciais(nome: string): string {
    return nome
        .trim()
        .split(/\s+/)
        .slice(0, 2)
        .map((parte) => parte[0]?.toUpperCase() ?? "")
        .join("");
}

function formatarDuracao(inicio: string, fim?: string | null): string {
    if (!fim) return "—";
    const inicioMs = new Date(inicio).getTime();
    const fimMs = new Date(fim).getTime();
    if (Number.isNaN(inicioMs) || Number.isNaN(fimMs) || fimMs < inicioMs) return "—";

    const totalSegundos = Math.round((fimMs - inicioMs) / 1000);
    const minutos = Math.floor(totalSegundos / 60);
    const segundos = totalSegundos % 60;

    if (minutos === 0) return `${segundos}s`;
    return `${minutos}min ${segundos}s`;
}

function formatarLocalizacao(latitude: string | null, longitude: string | null): string {
    if (latitude === null) {
        return "-";
    }
    return `${latitude}, ${longitude}`;
}

function OcorrenciaFoto({ src }: { src: string }) {
    const [carregando, setCarregando] = useState(true);
    const [comErro, setComErro] = useState(false);

    return (
        <a href={src} target="_blank" rel="noopener noreferrer" className={styles["ronda-occurrence-card__foto-link"]} aria-label="Abrir foto da ocorrência em tamanho real">
            <div className={styles["ronda-occurrence-card__foto-wrapper"]}>
                {carregando && !comErro && (
                    <div className={styles["ronda-occurrence-card__foto-loading"]} aria-hidden="true">
                        <span className={styles["ronda-occurrence-card__spinner"]} />
                    </div>
                )}

                {comErro ? (
                    <span className={styles["ronda-occurrence-card__foto-erro"]}>Não foi possível carregar a imagem</span>
                ) : (
                    <img
                        src={src}
                        alt="Foto anexada à ocorrência"
                        className={`${styles["ronda-occurrence-card__foto"]} ${carregando ? styles["ronda-occurrence-card__foto--carregando"] : ""}`}
                        onLoad={() => setCarregando(false)}
                        onError={() => {
                            setCarregando(false);
                            setComErro(true);
                        }}
                    />
                )}
            </div>
        </a>
    );
}
